import React from "react";
import PropTypes from "prop-types";
import FrequentQuestions from "../components/FrequentQuestions";
import Link from "gatsby-link";
import ReactTooltip from "react-tooltip";

export const EmployerPageTemplate = props => {
  const tempText =
    "Dynamic Temp Module<br/>(Find and hire temps easily!<br/>No temp fees, buy-outs, or contracts!)<br/>(Limited Time Access During Beta-Testing)";
  return (
    <main id="main" className="site-main">
      <ReactTooltip effect="solid" place="right" multiline />

      <div
        className="employers-content"
        dangerouslySetInnerHTML={{ __html: props.html }}
      />

      <div className="hero hero-subpage strong-overlay">
        <div className="hero-content text-center">
          <div className="container-fluid">
            <div className="container">
              <h1 className="h-70 weight-bold">
                Join The Swiss Monkey
                <br />
                Dental Community
              </h1>
            </div>
            <div className="mt-120 employer-pricing-tiers">
              <h2 className="h-60 m-0">Tier Options</h2>
              <p className="p-18 p-blue weight-light">
                For offices with less than 6 locations (Excluding Custom)
              </p>
              <div className="mt-50 pricing-section">
                <div className="pricing-card-container">
                  <a href="https://app.swissmonkey.io/users/sign_up">
                    <div className="pricing card">
                      <h2 className="h-60 p-blue m-0 weight-bold">Basic</h2>
                      <p className="p-18 p-blue weight-light">Free</p>
                      <div className="mt-50 text-center">
                        <div className="text-left pricing-col">
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Post unlimited jobs FREE!
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Job seekers get notified when you submit new
                            positions
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Preview applicant profiles
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Pay to view applicant's contact information
                            &amp; resume where applicable*
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Messaging{" "}
                            <span
                              data-tip="Coming Soon"
                              className="glyphicon glyphicon-exclamation-sign"
                            />
                          </p>
                          <br />
                          <small>
                            *$7 per DA, RDA, and front desk positions | $10 per
                            hygienist | $15 per DDS, specialist
                          </small>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="pricing-card-container">
                  <a href="https://app.swissmonkey.io/users/sign_up">
                    <div className="pricing card">
                      <h2 className="h-60 p-blue m-0 weight-bold">
                        Unlimited Search &amp; Connect
                      </h2>
                      <p className="p-18 p-blue weight-light">
                        $999/year, $249/quarterly, or $99/month
                      </p>
                      <div className="mt-50 text-center">
                        <div className="text-left pricing-col">
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Post Unlimited Jobs!
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Job seekers get notified when you submit new
                            positions
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; View full profile details submitted by
                            applicants, including their contact information
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Search and message candidates on the network
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Access to beta Temp Module (search &amp;
                            message temp only candidates)
                          </p>

                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Messaging{" "}
                            <span
                              data-tip="Coming Soon"
                              className="glyphicon glyphicon-exclamation-sign"
                            />
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Temp Module{" "}
                            <span
                              data-tip={tempText}
                              className="glyphicon glyphicon-exclamation-sign"
                            />
                          </p>
                          {/* <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Access to Concierge Service/Personalized
                            Recruiting
                          </p>
                          <p className="p-18 p-gray weight-light">
                            <span className="glyphicon glyphicon-ok-sign p-blue" />
                            &nbsp; Access to Practice Support Services
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="pricing-card-container">
                  <Link to="/contact">
                    <div className="pricing card">
                      <h2 className="h-60 p-blue m-0 weight-bold">Custom</h2>
                      <p className="p-18 p-blue weight-light">
                        Built Just For You!
                      </p>
                      <div className="mt-50 text-center">
                        <div className="text-center pricing-col padd-col">
                          <p className="p-18 p-gray weight-light">
                            We create custom packages for recruiters, offices
                            with 6+ offices, corporate offices, and Dental
                            Service Organizations. Please contact us for more
                            info!
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="section-steps section-steps-v2 box-shadow-inset">
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <div className="text-center">
                <h2 className="h-60 m-0">
                  We’re making it easy for Employers to build their dream team
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container container-650">
          <div className="steps mt-70">
            <div className="step">
              <div className="circle step-thumb">
                <p className="h-72 p-purple weight-light">1</p>
              </div>
              <div className="step-info">
                <h2 className="p-24 weight-bold p-purple">
                  {props.bullet1Title}
                </h2>
                <p className="p-18 p-gray">{props.bullet1Desc}</p>
              </div>
            </div>

            <div className="step">
              <div className="circle step-thumb">
                <p className="h-72 p-purple weight-light">2</p>
              </div>
              <div className="step-info">
                <h2 className="p-24 weight-bold p-purple">
                  {props.bullet2Title}
                </h2>
                <p className="p-18 p-gray">{props.bullet2Desc}</p>
              </div>
            </div>

            <div className="step">
              <div className="circle step-thumb">
                <p className="h-72 p-purple weight-light">3</p>
              </div>
              <div className="step-info">
                <h2 className="p-24 weight-bold p-purple">
                  {props.bullet3Title}
                </h2>
                <p className="p-18 p-gray">{props.bullet3Desc}</p>
              </div>
            </div>

            <div className="step">
              <div className="circle step-thumb">
                <p className="h-72 p-purple weight-light">4</p>
              </div>
              <div className="step-info">
                <h2 className="p-24 weight-bold p-purple">
                  {props.bullet4Title}
                </h2>
                <p className="p-18 p-gray">{props.bullet4Desc}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FrequentQuestions data={props.frequentQuestions} />
    </main>
  );
};

EmployerPageTemplate.propTypes = {
  title: PropTypes.string.isRequired
};

const EmployerPage = ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;

  return (
    <EmployerPageTemplate
      html={html}
      title={frontmatter.title}
      bullet1Title={frontmatter.bullet1Title}
      bullet1Desc={frontmatter.bullet1Desc}
      bullet2Title={frontmatter.bullet2Title}
      bullet2Desc={frontmatter.bullet2Desc}
      bullet3Title={frontmatter.bullet3Title}
      bullet3Desc={frontmatter.bullet3Desc}
      bullet4Title={frontmatter.bullet4Title}
      bullet4Desc={frontmatter.bullet4Desc}
      membership1={frontmatter.membership1}
      membership2={frontmatter.membership2}
      frequentQuestions={frontmatter.frequentQuestions}
    />
  );
};

EmployerPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default EmployerPage;

export const employerPageQuery = graphql`
  query EmployerPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        membership1
        membership2
        bullet1Title
        bullet1Desc
        bullet2Title
        bullet2Desc
        bullet3Title
        bullet3Desc
        bullet4Title
        bullet4Desc
        frequentQuestions {
          question
          answer
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/employer-page.js